import { MultiValuedListItem } from '../../../MultiValuedList'
import { EmailTableRowActivitiesContent } from '../EmailTableRowActivitiesContent'

import * as styles from './EmailTableRowActivitiesItem.module.css'

function EmailTableRowActivitiesItem({
  className = styles.EmailTableRowActivitiesItem,
  label,
  unread,
  ...itemProps
}) {
  return (
    <MultiValuedListItem {...itemProps} className={className} unread={unread}>
      <EmailTableRowActivitiesContent label={label} unread={unread} />
    </MultiValuedListItem>
  )
}

export default EmailTableRowActivitiesItem
